import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import EventDetails from 'components/blocks/EventDetails'
import EventDetailsFooter from 'components/blocks/EventDetails/Footer'

const meetings = [
  {
    title: 'Community Meeting',
    date: '10/15/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
  {
    title: 'Community Meeting',
    date: '10/22/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
  {
    title: 'Community Meeting',
    date: '10/29/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
  {
    title: 'Community Meeting',
    date: '11/5/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
  {
    title: 'Community Meeting',
    date: '11/12/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
  {
    title: 'Community Meeting',
    date: '11/19/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
  {
    title: 'Community Meeting',
    date: '11/26/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
  {
    title: 'Community Meeting',
    date: '12/3/2024',
    time: '10:00 AM - 11:00 AM',
    location: 'Insurance Lounge',
    address: '3572 St. Rose Pkwy Ste 100',
    city: 'Henderson, NV 89052',
  },
]

const ReatailLoungesGrantsPassEvents: React.FC = (): React.ReactElement => (
  <div>
    <HeaderMeta
      title='Insurance Agency In Las Vegas, NV | Insurance Lounge'
      description='Insurance Lounge is your one-stop-shop for insurance coverage in Las Vegas, Nevada. Shop Home, Auto, Life, Health & other insurance policies in seconds.'
      ogImg='/images/og-images/Beaverton.webp'
    />
    <PageHero theme={PageHeroTheme.group} right={true} hasOpacity={true}>
      You’re invited! Come join us for a special seasonal event at our Las Vegas location.
    </PageHero>
    <EventDetails meetings={meetings} location='LasVegas' locationPhoneNumber='725-218-1434' />
    <EventDetailsFooter
      disclaimer='Plans are insured through UnitedHealthcare Insurance Company or one of its affiliated companies. For Medicare Advantage Plans: A Medicare Advantage organization
      with a Medicare contract. For Dual Special Needs Plans: A Medicare Advantage organization with a Medicare contract and a contract with the State Medicaid Program.
      Enrollment in the plan depends on the plan’s contract renewal with Medicare. For accommodations of persons with special needs at meetings call 725-218-1434, TTY
      711. ©2023 United HealthCare Services, Inc. All Rights Reserved.'
    />
  </div>
)

export default ReatailLoungesGrantsPassEvents
